import { Component, ElementRef, Input, OnChanges, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { MatDialog } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import {
  EventsService, FundraiserService, PusherService, ScriptLoaderService, UtilService, VariablesService, VwoService
} from '../../../../shared/services';
import { AcknowledgeFormComponent } from '../../../acknowledge-form/components/acknowledge-form/acknowledge-form.component';
import { PaymentUtilService } from '../../../payment/services';

@Component({
  selector: 'app-donation-methods',
  templateUrl: './donation-methods.component.html',
  styleUrls: ['./donation-methods.component.scss']
})
export class DonationMethodsComponent implements OnInit, OnChanges, OnDestroy {

  @Input() public bank;
  @Input() public donateBtnLabel;
  @Input() public fundraiser;
  @Input() public origin;
  @Input() public isSipStory;
  @Input() tagLabel;
  @Input() recommendTag;
  @Input() theme;
  isMobile: any;
  currency;
  bankInfo = {
    account_number: '',
    name: '',
    ifcs: ''
  };
  payment_option = {
    wallet: 'wallet',
    paytm: 'paytm',
    upi: 'upi',
    bank: 'bank'
  };
  upiImageUrl = 'https://d1vdjc70h9nzd9.cloudfront.net/images/payment_gateways/payment-modes.png';
  isLoading = false;
  upiResponse;
  upiInview = false;
  showQR = true;
  isLoggedIn;
  userdata;
  @ViewChild('bankRef') public bankRef: ElementRef<HTMLElement>;
  @ViewChild('upiRef') public upiRef: ElementRef<HTMLElement>;
  generalSubs: Subscription[] = [];

  constructor(
    public utilService: UtilService,
    public fundraiserService: FundraiserService,
    public eventsService: EventsService,
    public pusherService: PusherService,
    public domSanitizer: DomSanitizer,
    public dialog: MatDialog,
    public variablesService: VariablesService,
    public scriptLoaderService: ScriptLoaderService,
    public bottomSheet: MatBottomSheet,
    public vwo: VwoService,
    public paymentUtilService: PaymentUtilService,
  ) { }

  ngOnInit() {
    this.isMobile = this.utilService.isMobile();
    this.generalSubs.push(this.utilService.isLoggedIn.subscribe(res => this.isLoggedIn = res));
    this.generalSubs.push(this.variablesService.userData.subscribe(res => this.userdata = res));
    this.generalSubs.push(
      this.variablesService.scrollIntoView.subscribe({
        next: (res) => {
          if (res.name === 'upi') {
            this.upiRef.nativeElement.scrollIntoView({
              behavior: 'smooth', block: 'center'
            });
          } else if (res.name === 'bank') {
            this.bankRef.nativeElement.scrollIntoView({
              behavior: 'smooth', block: 'center'
            });
          }
        }
      })
    );
  }
  ngOnChanges() {
    if (this.bank) {
      this.setBankDetails(this.bank);
    }
  }

  setBankDetails(data) {
    if (data && data.info_3) {
      const temp = data.info_3.split('|');
      this.bankInfo.account_number = temp[0];
      this.bankInfo.name = temp[1];
      this.bankInfo.ifcs = temp[2];
    }
  }

  /**
   * Get the url of acknowledgement
   * @param pg Payment Option Name
   * @param id Campaign Id
   */
  getUrlOfAck(pg, id) {
    return `contribute/payments.php?pg=${pg}&fmd_id=${id}`;
  }
  /**Go to the url */
  goTourl(url) {
    const full_url = `${this.utilService.domain_details.domain_url}/${this.getUrlOfAck(url, this.fundraiser.id)}`;
    this.utilService.nativeNavigation(full_url);
  }

  /**Open dialog */
  openDialog(type, amount?, ref?) {
    this.dialog.open(AcknowledgeFormComponent, {
      data: { mode: type, amount: amount, ref_no: ref },
      width: '100vw',
      height: '100vh',
      maxWidth: '600px',
      maxHeight: this.isMobile ? '100vh' : '550px',
    });
  }

  ngOnDestroy() {
    this.generalSubs.forEach(s => s.unsubscribe());
  }
}
